import "./import-modules";

import bootstrap from 'bootstrap';
import validate from 'jquery-validation';

import './scss/main.scss';

// import so that all get watched
import "./scss/_variables.scss";
import "./scss/_global.scss";

jQuery(document).ready(function () {

        var kids=jQuery("#about-slide .carousel-inner").children().length;
    var pick = Math.floor(Math.random() * kids);
    jQuery('#about-slide .carousel-inner div:eq('+pick+')').addClass('active');
    var ind = jQuery("#about-slide .carousel-indicators");
    for ( var i=1; i<= kids;i++) {
        ind.append('<li data-target="#about-slide" data-slide-to="'+i+'"></li>');
    }
    // Add missing classes to xmenu generated items
    // If there are multiple navbar dropdowns use nbd-x to make them unique

    jQuery('li.nav-item div.dropdown-menu').siblings("a").each(function (dropdownNumber) {
        jQuery(this).addClass("dropdown-toggle");
        jQuery(this).prop("id", "nbd-" + dropdownNumber);
        jQuery(this).attr({
            "role": "button",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false",
        })
        jQuery(this).siblings('div.dropdown-menu').attr("aria-labelledby", "nbd-" + dropdownNumber);
    });

    // Function to scroll to top of page.
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 50) {
            jQuery('#back-to-top').fadeIn('slow');
        } else {
            jQuery('#back-to-top').fadeOut('slow', function () {
                jQuery('#back-to-top').attr('style', 'display: none !important');
            });
        }
    });
    // Scroll body to 0px on click
    jQuery('#back-to-top').click(function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 400);
        return false;
    });

    // Hide default error messages
    jQuery.validator.messages.required = '';

    jQuery('.validate').validate({
        highlight: function (element) {
            jQuery(element).closest('.form-control').addClass('is-invalid');
        },
        unhighlight: function (element) {
            jQuery(element).closest('.form-control').removeClass('is-invalid');
        },
        errorElement: 'span',
        errorClass: 'label label-danger',
        errorPlacement: function (error, element) {
            if (element.parent('.input-group').length) {
                error.insertAfter(element.parent());
            } else {
                error.insertAfter(element);
            }
        }
    });
    

});